export default "__VITE_ASSET__qkdqJkMU__"